import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Download, Calendar } from "lucide-react";

export function ProfilesTabs() {
  const navigate = useNavigate();
  const IconCheck = (p) => (<svg viewBox="0 0 24 24" {...p}><path fill="currentColor" d="M9.55 17.1 4.9 12.45l1.4-1.4 3.25 3.25 7.2-7.2 1.4 1.4z"/></svg>);

  const tabs = [
    {
      key: "indus",
      label: "Industries & Fabricants",
      pains: [
        "Canal Amazon sous-performant vs coûts maîtrisés",
        "Santé catalogue (variations, prix, Buy Box) instable",
        "Manque de lisibilité des marges & de la demande",
      ],
      route: "/industriels-fabricants",
      ctaText: "Voir notre offre Industriels"
    },
    {
      key: "dnvb",
      label: "DNVB & Marques digitales",
      pains: [
        "Funnel Amazon (SEO → Ads → Store) à structurer",
        "Créatifs qui convertissent (A+, visuels, UGC) manquants",
        "Scale EU sans perdre la rentabilité",
      ],
      route: "/marques-dnvb",
      ctaText: "Voir notre offre DNVB"
    },
  ];
  const [active, setActive] = useState("indus");

  return (
    <section id="audit" className="py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-gradient-to-br from-primary/5 to-transparent rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-1/4 w-48 h-48 bg-gradient-to-tl from-accent/5 to-transparent rounded-full blur-3xl animate-pulse" style={{animationDelay: '2s'}}></div>
      </div>
      
      <div className="container mx-auto px-6 xl:px-8 2xl:px-12 relative z-10">
        <div className="max-w-7xl 2xl:max-w-8xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl xl:text-5xl font-inter font-bold mb-6">
              <span className="bg-gradient-to-r from-foreground via-primary to-foreground bg-clip-text text-transparent">
                Audit personnalisé
              </span>
            </h2>
            <p className="text-xl text-muted-foreground font-light max-w-3xl mx-auto mb-4">
              Identifiez vos opportunités de croissance selon votre profil business
            </p>
            <p className="text-base text-primary font-medium max-w-2xl mx-auto">
              👆 Choisissez votre profil ci-dessous pour un audit adapté à vos besoins
            </p>
          </div>

          <div className="mb-8 flex justify-center gap-4">
            {tabs.map((t) => (
              <button key={t.key} onClick={() => setActive(t.key)}
                className={`px-8 py-4 text-base font-semibold rounded-xl transition-all duration-300 border ${
                  active===t.key 
                    ? "bg-primary/10 text-primary border-primary/30 shadow-lg shadow-primary/10"
                    : "bg-card/50 text-muted-foreground hover:text-foreground border-border/50 hover:border-border hover:bg-card/80"
                }`}>
                {t.label}
              </button>
            ))}
          </div>

          {tabs.map((t) => active===t.key && (
            <div key={t.key} className="grid gap-12 rounded-3xl border border-border/20 bg-card/30 backdrop-blur-sm p-12 md:grid-cols-2 shadow-2xl">
              <div>
                <h3 className="text-2xl font-semibold mb-8 text-foreground">
                  Points de blocage identifiés
                </h3>
                <ul className="space-y-6">
                  {t.pains.map((p, i) => (
                    <li key={i} className="flex items-start gap-4 text-base">
                      <div className="mt-1 p-1 rounded-full bg-primary/20">
                        <IconCheck className="h-4 w-4 text-primary" />
                      </div>
                      <span className="text-muted-foreground leading-relaxed">{p}</span>
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="flex flex-col justify-center space-y-6">
                <div className="text-center">
                  <h4 className="text-xl font-semibold mb-4 text-foreground">
                    Prêt à passer à l'action ?
                  </h4>
                  <p className="text-muted-foreground mb-8">
                    Découvrez votre plan d'action personnalisé
                  </p>
                </div>
                
                <div className="flex flex-col gap-4">
                  <Button 
                    variant="cta-primary" 
                    size="lg" 
                    className="w-full" 
                    onClick={() => navigate(t.route)}
                  >
                    <Download className="h-4 w-4 mr-2" />
                    {t.ctaText}
                  </Button>
                  <Button 
                    variant="cta-secondary" 
                    size="lg" 
                    className="w-full"
                    onClick={() => navigate("/audit-gratuit")}
                  >
                    <Calendar className="h-4 w-4 mr-2" />
                    Planifier un RDV
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}